import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiroCards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGiroCards"><Path d="M2.5 4.5V4H2V4.5H2.5ZM17.5 4.5H18V4H17.5V4.5ZM17.5 15.5V16H18V15.5H17.5ZM2.5 15.5H2V16H2.5V15.5ZM21.5 8.5H22V8H21.5V8.5ZM21.5 19.5V20H22V19.5H21.5ZM6.5 19.5H6V20H6.5V19.5ZM5.5 8H5V9H5.5V8ZM7.5 9H8V8H7.5V9ZM2.5 5H17.5V4H2.5V5ZM17 4.5V15.5H18V4.5H17ZM17.5 15H2.5V16H17.5V15ZM3 15.5V4.5H2V15.5H3ZM21 8.5V19.5H22V8.5H21ZM21.5 19H6.5V20H21.5V19ZM17.5 9H21.5V8H17.5V9ZM7 19.5V15.5H6V19.5H7ZM5.5 9H7.5V8H5.5V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiroCards;
